module.exports = __webpack_public_path__ + "img/empty-base.8cfd9fd9.png";